export const calculateRowNumber = (index, currentPage, pageSize = 10) => {
  return currentPage >= 2
    ? index + 1 + (currentPage - 1) * pageSize
    : index + 1;
};
